/*  */
 /**   Vue BasePlugins.
 *    Plugins loaded here enter into the `Vue.prototype` singleton-type global scope.
  *
 *//*    ~ The "base" plugins are loaded before App mounts.  ~
  /         ~~ (also async "base" import()s are used) ~~
*//*    ~ "Lazy" plugins enter the global Vue scope just a bit later. ~
\*/
import SitePlugin from '@/plugins/site.js';
import StorePlugin from '@/plugins/vuex-store.js';
import EventBusPlugin from '@/plugins/event-bus.js';
import AxiosPlugin from '@/plugins/axios.js';
import SVCPlugin from '@/plugins/svc.js';
import I18nPlugin from '@/plugins/i18n.js';
import HelpersPlugin from '@/plugins/helpers.js';
import MatomoPlugin from '@/plugins/matomo.js';
// import MetaPlugin from '@/plugins/meta.js';
// import ObserveVisibilityPlugin from '@/plugins/observe-visibility.client.js';
// import IconsPlugin from '@/plugins/icons.js';
// import ComponentsPlugin from '@/plugins/components.js';
// import KeepScrollPositionPlugin from '@/plugins/keep-scroll-position.client.js';

export const BasePlugins = {
    name: 'base-plugins',

    globalProperties: {},

    async install (Vue) {

        // set site (taide.art)
        // site = SitePlugin.pluginProperties.site;
        // ====================================
        // const SitePlugin = await require('@/plugins/site.js').plugin;
        Vue.use(SitePlugin);
        Object.assign(this.globalProperties, SitePlugin.pluginProperties);

        // import vuex stores
        // store = StorePlugin.pluginProperties.store;
        // ====================================
        // const StorePlugin = await require('@/plugins/vuex-store.js').plugin;
        Vue.use(StorePlugin);
        Object.assign(this.globalProperties, StorePlugin.pluginProperties);

        // create global event bus
        // eventBus = EventBusPlugin.pluginProperties.eventBus;
        // ====================================
        // const EventBusPlugin = require('@/plugins/event-bus.js').plugin;
        Vue.use(EventBusPlugin);
        Object.assign(this.globalProperties, EventBusPlugin.pluginProperties);

        // axios HTTP library
        // axios = AxiosPlugin.pluginProperties.axios;
        //  NOTE: https://danlevy.net/you-may-not-need-axios/
        // ====================================
        // const AxiosPlugin = await require('@/plugins/axios.js').plugin;
        Vue.use(AxiosPlugin);
        Object.assign(this.globalProperties, AxiosPlugin.pluginProperties);

        // SVC backend API
        // SVC = SVCPlugin.pluginProperties.SVC;
        // ====================================
        // const SVCPlugin = await require('@/plugins/svc.js').plugin;
        Vue.use(SVCPlugin, this.globalProperties);
        Object.assign(this.globalProperties, SVCPlugin.pluginProperties);

        // localization
        // i18n = I18nPlugin.pluginProperties.i18n;
        // ====================================
        // const I18nPlugin = await require('@/plugins/i18n.js').plugin;
        Vue.use(I18nPlugin, this.globalProperties);
        Object.assign(this.globalProperties, I18nPlugin.pluginProperties);

        // helper functions
        // helpers = HelpersPlugin.pluginProperties.helpers;
        // ====================================
        // const HelpersPlugin = require('@/plugins/helpers.js').plugin;
        Vue.use(HelpersPlugin);
        Object.assign(this.globalProperties, HelpersPlugin.pluginProperties);


        Vue.use(MatomoPlugin);
        Object.assign(this.globalProperties, MatomoPlugin.pluginProperties);

        // vue-meta for dynamic meta tags
        // ====================================
        // const MetaPlugin = await require('@/plugins/meta.js').plugin;
        // Vue.use(MetaPlugin);
        import('@/plugins/meta.js')
            .then((esModule) => { Vue.use(esModule.plugin); })
            .catch((error) => { throw error; });

        // vue-observe-visibility
        // ====================================
        // const ObserveVisibilityPlugin = require('@/plugins/observe-visibility.client.js').plugin;
        // Vue.use(ObserveVisibilityPlugin);
        import('@/plugins/observe-visibility.client')
            .then((esModule) => { Vue.use(esModule.plugin); })
            .catch((error) => { throw error; });

        // vue2-touch-events
        // ====================================
        // const TouchEventsPlugin = require('@/plugins/touch-events.client.js').plugin;
        // Vue.use(TouchEventsPlugin);
        import('@/plugins/touch-events.client.js')
            .then((esModule) => { Vue.use(esModule.plugin); })
            .catch((error) => { throw error; });

        // icons
        // ====================================
        // const IconsPlugin = await require('@/plugins/icons.js').plugin;
        // Vue.use(IconsPlugin);
        import('@/plugins/icons.js')
            .then((esModule) => { Vue.use(esModule.plugin); })
            .catch((error) => { throw error; });

        // oruga-ui
        // ====================================
        // const OrugaPlugin = require('@/plugins/oruga-ui.js').plugin;
        // Vue.use(OrugaPlugin);
        import('@/plugins/oruga-ui.js')
            .then((esModule) => { Vue.use(esModule.plugin); })
            .catch((error) => { throw error; });

        // local components
        // ====================================
        // const ComponentsPlugin = require('@/plugins/components.js').plugin;
        // Vue.use(ComponentsPlugin);
        import('@/plugins/components.js')
            .then((esModule) => { Vue.use(esModule.plugin); })
            .catch((error) => { throw error; });

        // v-keep-scroll-position directive
        // ====================================
        // const KeepScrollPositionPlugin = require('@/plugins/keep-scroll-position.client.js').plugin;
        // Vue.use(KeepScrollPositionPlugin);
        import('@/plugins/keep-scroll-position.client.js')
            .then((esModule) => { Vue.use(esModule.plugin); })
            .catch((error) => { throw error; });

        // console.debug("Base pluginProperties", this.globalProperties);
    }
};

/**
 * LazyPlugins are loaded after the App has mounted.
 */
const LazyPluginLoaders = [
    () => import(/* webpackPreload: true */'@/plugins/dev-extreme.js'),
    () => import('@/plugins/iframe-resizer.js'),
    () => import('@/plugins/browser-check.client.js'),
    () => import('@/plugins/trackers.client.js')
    // () => import('@/plugins/masonry.js'),
    // () => import('@/plugins/infinite-loading.client.js'),
    // () => import('@/plugins/buefy.js'),
];

/**
 * ES module loader for the plugins.
 */
export const loadLazyPlugins = async (Vue, options) => {
    for (const loader of LazyPluginLoaders) {

        const esModule =
            await loader()
                .catch(console.error);

        Vue.use(esModule.plugin, options);
    }
    return Promise.resolve(Vue);
};

/**
 * Vue plugin wrapper to install them all.
 */
export const LazyPlugins = {
    name: 'lazy-plugins',

    install (Vue, options) {
        loadLazyPlugins(Vue, options)
            .then(() => {
                // console.debug("Plugins init complete!");
                return true;
            })
            .catch((error) => {
                console.error("Error loading async plugins!", error);
            });
    }
};

export default {
    BasePlugins,
    LazyPlugins
};
